if (!customElements.get('news-video-slider')) {
  customElements.define(
    'news-video-slider',
    class NewsVideoSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.swiperEl = this.querySelector('.swiper');
        this.columns = parseInt(this.dataset.columns) || 3;
        this.sliderInstance = false;

        this.initSlider();

        document.addEventListener('matchMobile', () => this.initSlider());
        document.addEventListener('unmatchMobile', () => this.initSlider());
      }

      initSlider() {
        this.destroySlider();

        const options = {
          slidesPerView: 1.15,
          spaceBetween: 16,
          threshold: 2,
          grabCursor: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'bullets',
          },
          breakpoints: {
            768: {
              slidesPerView: Math.min(this.columns, 2),
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: this.columns,
              spaceBetween: 24,
            },
          },
        };

        const modules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination];
        this.sliderInstance = new FoxTheme.Carousel(this.swiperEl, options, modules);
        this.sliderInstance.init();

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.sectionId) return;
            const index = Number(e.target.dataset.index || 0);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}